"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadMultipleFiles = exports.uploadFile = void 0;
var url = "https://api.cloudinary.com/v1_1/demo/image/upload";
var key = "docs_upload_example_us_preset";
var uploadFile = function (file) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.onerror = function (evt) { return reject(evt); };
        xhr.open("POST", url);
        xhr.onload = function () {
            resolve(JSON.parse(xhr.responseText).secure_url);
        };
        // xhr.upload.onprogress = (event) => {
        //   if (event.lengthComputable) {
        //     const percentage = (event.loaded / event.total) * 100;
        //     onProgress(Math.round(percentage));
        //   }
        // };
        var formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", key);
        xhr.send(formData);
    });
};
exports.uploadFile = uploadFile;
var dataURItoBlob = function (dataUri) {
    var _a;
    var arr = dataUri.split(",");
    var mime = (_a = arr[0]) === null || _a === void 0 ? void 0 : _a.match(/:(.*?);/);
    if (!mime)
        return null;
    var base64 = atob(arr[1]);
    var n = base64.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = base64.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime[1] });
};
var fileToDataUri = function (file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (event) {
            if (event && event.target) {
                var data = dataURItoBlob(event.target.result);
                resolve(data);
            }
        };
        reader.readAsDataURL(file);
    });
};
var downloadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        fileToDataUri(file).then(function (dataUri) {
            var link = document.createElement("a");
            link.setAttribute("href", window.URL.createObjectURL(dataUri));
            link.setAttribute("download", "".concat(file.name));
            document.body.appendChild(link);
            link.click();
            //@ts-ignore
            link.parentNode.removeChild(link);
        });
        return [2 /*return*/];
    });
}); };
var downloadMultipleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        files.forEach(function (file) {
            downloadFile(file);
        });
        return [2 /*return*/];
    });
}); };
exports.downloadMultipleFiles = downloadMultipleFiles;
